import { Button } from "@npco/zeller-design-system";
import * as Icon from "@npco/zeller-design-system/icon";

import tap from "./authenticate-prompt/tap.jpg";

export function AuthenticationPrompt({
	onLogin: handleLogin,
}: {
	onLogin: () => Promise<void>;
}) {
	return (
		<div className="h-full flex items-center">
			<div className="flex flex-1">
				<div className="flex flex-col flex-1 min-h-[432px]">
					<div className="flex flex-col flex-1 p-40">
						<div className="flex flex-1 flex-col gap-24">
							<h1 className="text-[32px] leading-[40px]">
								Accept payments anywhere, instantly
							</h1>
							<div className="text-md">
								Connect your Zeller Terminal in minutes and start taking
								payments.
							</div>
							<ul class="space-y-8">
								<li class="flex items-center text-md gap-x-8">
									<div className="text-blue-1000">
										<Icon.Checkmark />
									</div>
									<span className="text-md">
										No monthly fees or lock-in contracts
									</span>
								</li>
								<li class="flex items-center gap-x-8">
									<div className="text-blue-1000">
										<Icon.Checkmark />
									</div>
									<span className="text-md">
										Fast, reliable fund settlements
									</span>
								</li>
								<li class="flex items-center gap-x-8">
									<div className="text-blue-1000">
										<Icon.Checkmark />
									</div>
									<span className="text-md">
										Built for businesses of all sizes
									</span>
								</li>
							</ul>
						</div>
						<div className="w-[161px] justify-end">
							<Button label="Log in to Zeller" onClick={handleLogin} />
						</div>
					</div>
				</div>
				<div className="flex flex-1">
					<img
						src={tap}
						alt="Zeller Terminal card present purchase"
						className="object-fit w-full h-full"
					/>
				</div>
			</div>
		</div>
	);
}
